/**
 * StubPage
 *
 * Placeholder for routes described in the spec but not yet built out
 * (Engagement WIP Summary, Staff Utilization Report, Cut-Off Settings,
 * Dashboard). Kept as one small reusable component rather than duplicating
 * the same "coming soon" markup per page.
 */
export const StubPage = ({ title, description }) => (
  <div className="flex min-h-[50vh] flex-col items-center justify-center rounded-lg border border-dashed border-edge text-center">
    <h2 className="text-base font-semibold text-primary">{title}</h2>
    {description && <p className="mt-1 max-w-md text-sm text-muted">{description}</p>}
  </div>
);
